interface PromoPriceProps {
  original: string;
  current: string;
  className?: string;
  align?: "start" | "end";
}

export function PromoPrice({
  original,
  current,
  className = "",
  align = "end",
}: PromoPriceProps) {
  return (
    <span className={`pep-promo-price pep-promo-price--${align}${className ? ` ${className}` : ""}`}>
      <span className="pep-promo-price__current">{current}</span>
      <span className="pep-promo-price__original">{original}</span>
    </span>
  );
}

interface PromoPriceUsdProps {
  originalUsd: number;
  promoUsd: number;
  className?: string;
}

export function PromoPriceUsd({ originalUsd, promoUsd, className = "" }: PromoPriceUsdProps) {
  const fmt = (n: number) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    }).format(n);
  return (
    <PromoPrice
      original={fmt(originalUsd)}
      current={fmt(promoUsd)}
      className={className}
      align="start"
    />
  );
}
